import { CurrencyCode } from '@percent/utility'

import { NativeApplyModalContext } from '@percent/cause-dashboard/constants/nativeApply/getResolvedNativeApplyContext'
import { SmartApplyPartnerConfigKey } from '@percent/cause-dashboard/constants/smartApplyPartners'

export type SavingsPartner = {
  id: string
  displayName: string
  logo: string
  monthlyPrice: number
  discountedMonthlyPrice: number
  discountText: string
  tooltipText?: string
  smartApply?: { partnerKey: SmartApplyPartnerConfigKey; modalContext: NativeApplyModalContext }
  partnerUrl?: string
}

export const SAVINGS_CALCULATOR_CURRENCY: CurrencyCode = 'USD'

export const SAVINGS_CALCULATOR_STORY_ID = '192662864576604'
